import * as React from 'react';

export interface MainRegionProps {
  className?: string;
}

export class MainRegion extends React.Component<MainRegionProps> {
  public static defaultProps = {
    className: ''
  };

  public render() {
    const { className } = this.props;

    return <main className={`${className}`}>{this.props.children}</main>;
  }
}
